
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiHydraulic06 as ObiHydraulic06Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-hydraulic-06.js';
 
 
 

 
 export const ObiHydraulic06 = createComponent({
   react: React,
   tagName: 'obi-hydraulic-06',
   elementClass: ObiHydraulic06Element,
   events: {
     
   }
  });
 
 